import { render, staticRenderFns } from "./ITRSpouseIDCard.vue?vue&type=template&id=2ece8040&scoped=true&"
import script from "./ITRSpouseIDCard.vue?vue&type=script&lang=ts&"
export * from "./ITRSpouseIDCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece8040",
  null
  
)

export default component.exports